import { render } from "./SignMessage.vue?vue&type=template&id=58dbc2f8"
import script from "./SignMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignMessage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Wallet/SignMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58dbc2f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58dbc2f8', __exports__)) {
    api.reload('58dbc2f8', __exports__)
  }
  
  module.hot.accept("./SignMessage.vue?vue&type=template&id=58dbc2f8", () => {
    api.rerender('58dbc2f8', render)
  })

}


export default __exports__